export default function BardFlchFirstaidTimeline() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-10">
      <div className="flex flex-col items-center justify-center gap-3 rounded-xl bg-gray-100 px-2 py-3 text-center sm:col-span-3">
        <span className="rounded bg-yellow-500 px-2 py-1 text-xs font-bold text-yellow-950">
          Teil 1
        </span>
        <div className="flex flex-col gap-1">
          <span className="font-bold">eLearning</span>
          <span className="text-gray-800">Online, ca. 3 Stunden</span>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center gap-3 rounded-xl bg-gray-100 px-2 py-3 text-center sm:col-span-7">
        <span className="rounded bg-blue-600 px-2 py-1 text-xs font-bold text-white">
          Teil 2
        </span>
        <div className="flex flex-col gap-1">
          <span className="font-bold">Praktischer Kurs</span>
          <span className="text-gray-800">
            An einem BLINK Standort, 7 Stunden
          </span>
        </div>
      </div>
    </div>
  )
}
